import { mapState, mapActions } from 'vuex'

export default {
  name: 'VideoChatSelectorButton',
  props: {
    name: {
      type: String,
      require: true
    },
    index: {
      type: Number,
      require: false,
      default: 0
    },
    model: {
      type: Array,
      require: false,
      'default': () => []
    },
    disabled: {
      type: Boolean,
      require: false,
      'default': () => false
    },
    overlay: {
      type:Boolean,
      default: () => false,
    }
  },
  computed: {
    ...mapState({
      buttonId: state => state.selectVideoChatModal.buttonId,
      modalIndex: state => state.selectVideoChatModal.index,
      value: state => state.selectVideoChatModal.value
    })
  },
  watch: {
    value (to) {
      if (to &&
          this.buttonId === this.name &&
          this.index === this.modalIndex) {
        // console.log(this.name, to)
        this.changeFile(to)
      }
    }
  },
  methods: {
    ...mapActions({
      showSelectExtraInfoModal: 'selectVideoChatModal/show',
    }),
    showExtraInfoSelector () {
      this.showSelectExtraInfoModal({
        buttonId: this.name,
        index: this.index,
        overlay: this.overlay
      })
    },
    changeFile (data) {
      this.$emit('childs-change', {
        name: this.name,
        index: this.index,
        data: data
      })
    }
  }
}
